import React from "react";
import Error from "@material-ui/icons/ReportProblem";
import Check from "@material-ui/icons/Check";

const TernaryField = (data) => {
  if (data.record[data.source] === false) return <Error />;
  if (data.record[data.source] === true) return <Check />;
  return null;
};

export default TernaryField;



// WEBPACK FOOTER //
// ./src/components/fields/TernaryField.js